import Header from "../../components/Header";
import ContentWrapper from "../../components/ContentWrapper";
import BoxSignsPermanent from "./_components/BoxSignsPermanent";

const SignsPermanent = () => (
  <>
    <div className="px-[10px] pt-[5px]">
      <Header />
    </div>
    <ContentWrapper>
      <BoxSignsPermanent />
    </ContentWrapper>
  </>
);

export default SignsPermanent;
